import { AccordionOutcomeImpactProps } from './accordionOutcomeImpact.types';
import { useLabels } from 'src/StoreDataProvider';
import Accordion from 'src/components/atoms/Accordion';
import LanguageSpan from 'src/components/atoms/LanguageSpan';

const AccordionOutcomeImpact: (
  props: AccordionOutcomeImpactProps
) => JSX.Element = ({ title, isActive, indicators, targets }) => {
  const labels = useLabels();
  return (
    <Accordion
      title={title}
      isActive={isActive}
      className={'accordion__outcome-impact'}
    >
      <div className="contentAcc" style={{ overflow: 'hidden' }}>
        <div className="description">
          {targets.map((target, index) => {
            const key = `${title.toLowerCase()}-description-${index}`;
            return target !== '0' ? (
              <p data-cy={key} key={key}>
                <LanguageSpan text={target} keyPrefix={key}></LanguageSpan>
              </p>
            ) : (
              ''
            );
          })}
        </div>

        <table>
          <thead>
            <tr className="indicator_Achievement_Title">
              <th id="indicator" scope="col">
                {labels.indicator}
              </th>
              <th id="achievement" scope="col">
                {labels.achievement}
              </th>
            </tr>
          </thead>
          <tbody>
            {indicators.length === 0 && (
              <tr>
                <td data-cy="impact-null">
                  {title === 'Impact' ? labels.noImpact : labels.noOutcome}
                </td>
              </tr>
            )}
            {indicators.map((indicator, index) => {
              const indicatorStatusFormatted = (
                indicator.status.charAt(0).toUpperCase() +
                indicator.status.slice(1)
              ).trim();
              const key = `${title.toLowerCase()}-indicator-${index}`;
              return (
                <tr
                  key={key}
                  data-cy={key}
                  className="indicator_Achievement_Box"
                >
                  <td>
                    <LanguageSpan
                      text={indicator.value}
                      keyPrefix={key}
                    ></LanguageSpan>
                  </td>
                  <td
                    data-cy={`${title.toLowerCase()}-achievement-${index}`}
                    className={`achievement ${
                      indicatorStatusFormatted === labels.fullfilled
                        ? 'fullfilled'
                        : indicatorStatusFormatted === labels.partiallyFulfilled
                        ? 'partiallyFulfilled'
                        : indicatorStatusFormatted === labels.notFulfilled
                        ? 'notFulfilled'
                        : '-'
                    }`}
                  >
                    {' '}
                    {indicatorStatusFormatted}{' '}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Accordion>
  );
};

export default AccordionOutcomeImpact;
